import PropTypes from 'prop-types';
import React from 'react'
import createReactClass from 'create-react-class';
import ReactDOM from 'react-dom';
import Slider from '~/components/react-slide/src';

export default createReactClass({

	propTypes: {
		changeData: PropTypes.func.isRequired,
		prevSlide: PropTypes.func.isRequired,
		nextSlide: PropTypes.func.isRequired,
		sessionUser: PropTypes.object.isRequired
	},

	labels: ['Over three years old', 'Under three years old', 'Under a year old', 'Recently launched', 'Preparing to launch', 'Thinking about it'],

	tooltipStyles: {
		position: 'absolute',
        bottom: '-50%',
        width: '150px',
        left: '40px',
        color: 'white'
	},

	handleStyles: {
		background: 'none',
		height: 0,
		margin: ''
	},

	getInitialState: function() {
		let input_name = 'what_stage',
			text_val = (input_name in this.props.sessionUser.custom) ? this.props.sessionUser.custom[input_name] : this.labels.length-1,
			default_val = this.labels.indexOf(text_val);
		return {
			default_val: default_val > -1 ? default_val : this.labels.length - 1,
			input_name: input_name,
			field: input_name
		}
	},

	changeData: function(value) {
		var data = {};
		data[this.state.field] = this.labels[value];
		this.props.changeData({}, data)
	},

    renderHandle: function(props){
        return <div {...props}><span style={this.tooltipStyles}>{this.labels[props.value]}</span></div>
    },

	render: function() {

		return (
			<div className="slide-wrapper">
				<header className="bg-mid-main ptop20 pbot20">
					<h4 className="text-white text-center mtop0 mbot0">What stage is your company at currently?</h4>
				</header>
				<div className="inner bg-light-main bg-slightly-transparent ptop40">

					{ /*<ReactUISlider { ...this.sliderProps } onChange={this.refreshTooltip} onAfterChange={this.changeData} />*/ }
					<Slider 
						orientation="vertical"
						startValue={0}
						endValue={this.labels.length - 1}
						//defaultValue={5}
						onChange={this.changeData}
						defaultValue={this.state.default_val}
						handleFactory={this.renderHandle}
						tickStep={1}
						handleStyle={this.handleStyles} />

					<div className="clearfix"></div>

				</div>
				<footer className="bg-deep-main p20">
					<p className="lead mbot0 text-center text-white">
						<i className="icon icon-chevron-left pull-left clickable" onClick={this.props.prevSlide}></i>
						Slide up & down to choose
						<i className="icon icon-chevron-right pull-right clickable" onClick={this.props.nextSlide}></i>
					</p>
				</footer>

			</div>

		)
	}

})



// WEBPACK FOOTER //
// ./src/js/views/Registration/RegistrationSlides/WhatStageSlidePart.jsx